class TestiSlider extends HTMLElement {
    constructor() {
        super()
        this.swiper = null
    }

    connectedCallback() {
        const container = this.querySelector('.swiper')
        const prevButton = this.querySelector('[aria-label="Previous testimonials"]')
        const nextButton = this.querySelector('[aria-label="Next testimonials"]')

        if (!container) return

        this.swiper = new Swiper(container, {
            speed: 400,
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {
                prevEl: prevButton,
                nextEl: nextButton,
                disabledClass: 'opacity-30 cursor-not-allowed',
            },
            breakpoints: {
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                },
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous testimonials',
                nextSlideMessage: 'Next testimonials',
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        })
    }

    disconnectedCallback() {
        if (this.swiper) {
            this.swiper.destroy(true, true)
            this.swiper = null
        }
    }
}

customElements.define('testi-slider', TestiSlider)